//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    angular
        .module('container.widgets')
        .directive('srsngMaskHeader', srsngMaskHeader);

    function srsngMaskHeader() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mask-header/mask-header.html',
            scope: {
                title: '@'
            },
            controller: controller
        };

        function controller($scope, $filter, $element) {
            $scope.translationstring = $scope.title.slice();
            $scope.translationstring = $scope.translationstring.replace(/^\'+|\'+$/g, '');
            $scope.title = null;
            $element.removeAttr('title')
        }

    }

}());
